import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    minWidth: 560,
    maxHeight: '60vh',
    overflowY: 'auto'
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '10px 0',
    borderBottom: '1px solid #e0e0e0'
  },
  // Dimmed, never hidden: a sender someone deliberately turned off is information.
  rowDisabled: {
    opacity: 0.55
  },
  cell: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0
  },
  value: {
    fontWeight: 600,
    overflowWrap: 'anywhere'
  },
  label: {
    color: '#6b7280'
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginLeft: 'auto'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    paddingTop: 8
  },
  formRow: {
    display: 'flex',
    gap: 16,
    alignItems: 'flex-start'
  },
  field: {
    flex: 1
  },
  empty: {
    color: '#6b7280',
    padding: '8px 0'
  },
  typeLabel: {
    color: '#6b7280'
  },
  // Explicit next to the dimming, so the state is announced and not only implied by opacity.
  disabledLabel: {
    color: '#6b7280',
    fontWeight: 600
  }
});
export default useStyles;